<template>
    <div class="ws-table-meta">
        <div><small>{{ meta }}</small></div>
        <div v-if="meta" class="ws-table-sum" v-html="parsedSummary"></div>
        <div class="ws-table-navigation">
            <div v-if="meta && meta.current_page!=1" class="ws-button small" @click="goToPreviousPage">Previous Page</div>
            <div v-if="meta && meta.current_page!=meta.last_page" class="ws-button small" @click="goToNextPage">Next Page</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TableMeta",
    props: {
        sum: String,
        meta: Object,
        format: {
          type: String,
          default: 'table'
        },
    },
    data() {
        return {
        }
    },
    methods: {
        goToNextPage() {
            
        },
        goToPreviousPage() {
            
        },
    },
    computed: {
        parsedSummary() {
            return this.sum.replace('%',this.meta ? this.meta.total : 0);
        }
    }
}
</script>